import React from 'react';
import { Typography, Alert } from 'antd';
import BreakdownRequestList from '../components/BreakdownRequestList';
import { APP_CONFIG } from '../utils/constants';

const { Text } = Typography;

const BreakdownRequests = () => {
  return (
    <div className="breakdown-requests-page" style={{ padding: '16px' }}>
      <div style={{ marginBottom: 12 }}>
        <Alert
          type="info"
          message="Next steps"
          description={
            <Text>
              In order to proceed further please <a href={`tel:${APP_CONFIG.CALL_NUMBER}`}>Call RNR</a> and provide the breakdown reference number.
            </Text>
          }
          showIcon
        />
      </div>

      <BreakdownRequestList />
    </div>
  );
};

export default BreakdownRequests;
